'use client';
import React, { FunctionComponent, useMemo } from 'react';
import styles from './styles.module.scss';
import { ArrowLeftIcon } from '../../Icons';
import { useCheckoutContext } from '../CheckoutContext';

export const EmbedBackToSiteBanner: FunctionComponent = () => {
    const { checkoutState } = useCheckoutContext();
    const parentWindowUrl = useMemo(() => {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('parent_window_url');
    }, []);

    if (!parentWindowUrl || checkoutState.origin !== 'embed') return null;

    return (
        <a
            href={decodeURIComponent(parentWindowUrl)}
            target="_blank"
            rel="noreferrer"
            className={styles.banner}
        >
            <ArrowLeftIcon />
            Back to Website
        </a>
    );
};
